import { API_URL } from "@/config/config";
import $http from "@/Utils/$http";
const reservationsLink = params =>
  `${API_URL}business/${params.businessId}/branches/${params.branchId}/reservations/`;

export const getReservationsList = async params =>
  (await $http.get(reservationsLink(params), { params })).data;

export const getReservationsFiltered = async params =>
  (await $http.get(reservationsLink(params) + "filter", { params })).data;

export const getReservationData = async params =>
  (await $http.get(reservationsLink(params) + params.id)).data;

export const createReservation = async params =>
  (await $http.post(reservationsLink(params), params)).data;

export const updateReservation = async params =>
  (await $http.post(reservationsLink(params) + params.id, params)).data;

export const deleteReservation = async params =>
  (await $http.post(reservationsLink(params) + params.id + "/delete")).data;
